import {Component, Input, OnInit} from '@angular/core';
import { MaterialModule } from 'src/app/app.materials';
import { SummaryCardsComponent } from './summary-cards/summary-cards.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-portfolio-summary',
  templateUrl: './portfolio-summary.component.html',
  styleUrls: ['./portfolio-summary.component.scss'],
  standalone: true,
  imports: [MaterialModule, SummaryCardsComponent, CommonModule]
})
export class PortfolioSummaryComponent implements OnInit {
  @Input() summaryRaw: any;
  @Input() performanceData: any;
  @Input() benchmark: any = null;
  @Input() etfOnly = false;

  portfolioPerformance: any = null;

  constructor() { }

  ngOnInit(): void {
    this.initPortfolioPerformance();
  }

  initPortfolioPerformance() {
    if (this.performanceData) {
      this.performanceData.map(d => {
        if (d.Ticker == "Portfolio") {
          this.portfolioPerformance = d;
        }
      })
    }
  }
}
